var DEVELOPMENT = window.location.href.indexOf('dev.') !== -1 ? true : false;
var ENABLE_ANALYTICS = true; //DEVELOPMENT === false;
var CURRENCY = window.location.href.indexOf('brisbane.') !== -1 ? 'AUD' : 'CAD'; 
var $spinner = null;

// remove cart item
$('#cart-container').on('click', '.btn-remove-item', function(e) {
	var $tr = $(e.currentTarget).closest('tr');
	$.ajax({
		type : "POST",
		data : { 
			action : 'remove',
			type   : $tr.attr('data-type'),
			id     : $tr.attr('data-id')
		},
		cache    : false,
		dataType : 'json',
		success : function(response) {
			var cart = response.cart;
			if (cart.items.length === 0 && cart.reservations.length === 0) {
				return window.location.reload();
			}
			refreshCart();
		}
	});
	return false;
});

// apply promo code
$('#cart-container').on('click', '.button-apply', function(e) {
	var code = String($('.input-promo').val()).toUpperCase().trim();
	if (code.length === 0) {
		return;
	}
	$.ajax({
		type     : "POST",
		url      : window.location + "/promo",
		data     : { code : code },
		cache    : false,
		dataType : 'json',
		success : function(response) {
			if (response.promoType === 'promo') {
				if (response.success === 1) {
					refreshCart();
				}
				else {
					$('.alert-discount').show().text(response.message);
				}
			}
			else if (response.promoType === 'giftcard') {
				if (response.success === 1) {
					refreshCart();
				}
				else {
					$('.alert-discount').show().text(response.message);
				}
			}
		}
	});
});

// remove promo
$('#cart-container').on('click', '.btn-remove-promo', function(e) {
	var $tr = $(e.currentTarget).closest('tr');
	$.ajax({
		type : "POST",
		data : { 
			action : 'removePromo',
			code   : $tr.attr('data-code'),
		},
		cache    : false,
		dataType : 'json',
		success : function(response) {
			refreshCart();
		}
	});
	return false;
});

// remove gift card
$('#cart-container').on('click', '.btn-remove-gift-card', function(e) {
	var $tr = $(e.currentTarget).closest('tr');
	$.ajax({
		type : "POST",
		data : { 
			action : 'removeGiftCard',
			id     : $tr.attr('data-id'),
		},
		cache    : false,
		dataType : 'json',
		success : function(response) {
			refreshCart();
		}
	});
	return false;
});

// promo input enter key
$('#cart-container').on('keydown', '.input-promo', function(e) {
	if (e.which === 13) {
		$('.button-apply').click();
	}
});

// cancel button
$('#cart-container').on('click', '.link-cancel', function(e) {
	history.back();
});

/**
 * Complete booking
 */
var bookingProcessing = false;
var $completeButton = $('.button-complete-text');
var completeButtonText = $completeButton.eq(0).text();
var cartTitle = $('.text-title');
$('#cart-container').on('click', '.button-complete', function(e) {
	e.preventDefault();
	hideAlert();

	if (bookingProcessing) {
		return;
	}
	bookingProcessing = true;

	$completeButton = $('.button-complete');
	$completeButton.html('<span class="position-relative d-inline-block">Processing<span>');
	startSpinner();
	
	var data = {
		action    : 'purchase',
		email     : $('.form-email').val().trim(),
		firstname : $('.form-firstname').val().trim(),
		lastname  : $('.form-lastname').val().trim(),
		phone     : $('.form-phone').val().trim(),
		paymentTokens : []
	};
	
	// form should be filled
	if (data.email.length == 0 || data.firstname.length == 0 || data.lastname.length == 0 || data.phone.length == 0) {
		return showAlert('Please fill out the entire form before booking.');
	}

	// data.email valid
	if (!EMAIL_REGEX.test(data.email)) {
		return showAlert('Your email doesn\'t appear to be valid.');
	}

	// test phone
	if (/[A-Za-z]/.test(data.phone) || data.phone.length < 6) {
		return showAlert('Your phone number doesn\'t appear to be valid.');
	}
	// warn if phone not in brisbane
	if (CITY === 'Brisbane' && /^(\+?1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/.test(data.phone) && $('#acceptBookNote:checked').length === 0) {
		return showAlert('<span class="text-uppercase">North American phone number detected</span><br/><br/> <div class="form-check"><input type="checkbox" class="form-check-input" id="acceptBookNote"/><label class="form-check-label" for="acceptBookNote"><span class="text-normal">By clicking the checkbox, you acknowledge that this experience is in Brisbane, Australia.</span></label></div>');
	}
	
	var hasPayment = $('.form-card-name').length === 1;
	if (hasPayment) {
		var cardName    = $('.form-card-name').val().trim();
		var cardNumber  = $('.form-card-number').val().trim();
		var cardMonth   = $('.form-card-month').val().trim();
		var cardYear    = $('.form-card-year').val().trim();
		var cardCCV     = $('.form-card-ccv').val().trim();
		var cardCountry = $('.form-card-country').val();
		var cardZIP     = $('.form-card-zip').val().trim();

		Stripe.setPublishableKey(DEVELOPMENT ? STRIPE_KEYS.test : STRIPE_KEYS.live);

		if (cardName.length == 0) {
			return showAlert('Please enter the name on the card.');
		}

		// test card number
		if (!Stripe.card.validateCardNumber(cardNumber)) {
			return showAlert('Your card number doesn\'t appear to be valid.');
		}

		// test card month / year
		if (!Stripe.card.validateExpiry(cardMonth, cardYear)) {
			return showAlert('Your card expiration number doesn\'t appear to be valid.');
		}

		// test card ccv
		if (!/^\d\d\d\d?$/.test(cardCCV)) {
			return showAlert('Your card security code (CCV) doesn\'t appear to be valid.');
		}

		if (cardCountry === 'CA' && !/^(?:[A-Z]\d[A-Z][ -]?\d[A-Z]\d)$/i.test(cardZIP)) {
			return showAlert('Your postal code doesn\'t appear to be valid.');
		}
		if (cardCountry === 'US' && !/^\d{5}(?:-\d{4})?$/.test(cardZIP)) {
			return showAlert('Your zip code doesn\'t appear to be valid.');
		}
		if (cardCountry === 'AU' && !/^(?:(?:[2-8]\d|9[0-7]|0?[28]|0?9(?=09))(?:\d{2}))$/.test(cardZIP)) {
			return showAlert('Your postcode doesn\'t appear to be valid.');
		}

		var stripeData = {
			name            : cardName,
			number          : cardNumber,
			exp_month       : cardMonth,
			exp_year        : cardYear,
			cvc             : cardCCV,
			address_country : cardCountry,
			address_zip     : cardZIP
		};

		// tokenize card
		stripeToken(data, stripeData, 0);
		return;
	}	
	completeBooking(data);
}); // click purchase

/**
 * Get stripe token
 */
function stripeToken(data, stripeData, count) {
	var venueId = TRANSACTIONS_VENUES[count];
	if (typeof STRIPE_KEYS2 !== 'undefined' && CITY === 'Digital' && venueId !== 363) {
		Stripe.setPublishableKey(DEVELOPMENT ? STRIPE_KEYS2.test : STRIPE_KEYS2.live);
	}
	else {
		Stripe.setPublishableKey(DEVELOPMENT ? STRIPE_KEYS.test : STRIPE_KEYS.live);
	}

	Stripe.card.createToken(stripeData, function(status, response) {
		// tokenization error
		if (response.error) {
			return showAlert(response.error.message);
		}
		data.paymentTokens.push(response.id);
		if (count < TRANSACTIONS_VENUES.length - 1) {
			return stripeToken(data, stripeData, count + 1);
		}
		completeBooking(data);
	});
}

/**
 * Complete booking
 */
function completeBooking(data) {
	// we have a token
	$.ajax({
		type     : "POST",
		data     : JSON.stringify(data),
		cache    : false,
		dataType : 'json',
		contentType: 'application/json',
		success  : function(response) {
			if (!response.success) {
				if (response.reload) {
					window.location.reload();
					return;
				}
				if (String(response.message).indexOf('spots available') > 0) {
					showAlert("Sorry, that time is no longer available.");
					return;
				}
				return showAlert(response.message);
			}

			window.scrollTo(0, 0);
			$('.h-thankyou').hide();
			$('.cart-thankyou').show();
			$('.cart-name').text(data.firstname + ' ' + data.lastname);
			$('.cart-confirmation').text(response.data.order.id);
			$('.text-title').text('Purchase Complete');

			var order = response.data.order;
			if (ENABLE_ANALYTICS) {
				if (typeof fbq !== 'undefined') {
					fbq('track', 'Purchase', { value: order.total, currency: CURRENCY });
				}
				if (typeof ttq !== 'undefined') {
					ttq.track('CompletePayment', { value: order.total, currency: CURRENCY });
				}

				// ecommerce event
				var affiliation = document.location.host + '/' + (KIOSK_MODE ? 'kiosk/' + kioskLocation : site);
				var items = [];
				var promoCode = "";
				order.receipts.forEach(function(receipt) {
					receipt.items.forEach(function(item) {
						if (item.discountCode) {
							promoCode = item.discountCode;
						}
						items.push({ 
							id       : item.id,
							name     : item.name,
							brand    : CITY,
							category : item.type,
							quantity : item.quantity,
							price    : item.price
						});
					});
				});
				gtag('event', 'purchase', {
					send_to        : "G-9BF9PSVTG2",
					transaction_id : order._id,
					affiliation    : affiliation,
					value          : order.total,
					currency       : CURRENCY,
					tax            : order.tax,
					shipping       : 0,
					coupon         : promoCode,
					items          : items
				});
			}
		},
		error : function(data) {
			return showAlert('We are sorry, but we couldn\'t complete your purchase. Please try again in a few minutes.');
		},
		complete : function(data) {
			stopSpinning();
			bookingProcessing = false;
		}
	});
}

$('#cart-container').on('click', '.button-add-to-cart', function(e) {
	e.preventDefault();
	hideAlert();

	if (bookingProcessing) {
		return;
	}
	bookingProcessing = true;

	$completeButton = $('.button-complete');
	$completeButton.html('<span class="position-relative d-inline-block">Processing<span>');
	startSpinner();
	
	var $button = $(e.currentTarget);
	var data = {
		venueId : parseInt($button.attr('data-venue')),
		eventId : parseInt($button.attr('data-event')),
		date    : parseInt($button.attr('data-date')),
		time    : $button.attr('data-time'),
		persons : parseInt($button.attr('data-persons')),
		upsell  : true,
	};

	// add to cart
	$.ajax({
		url      : window.location + "/add",
		type     : "POST",
		data     : JSON.stringify(data),
		cache    : false,
		dataType : 'json',
		contentType: 'application/json',
		success  : function(response) {
			if (response.success) {
				return refreshCart();
			}
			return showAlert(response.message);
		},
		error : function(data) {
			return showAlert('We are sorry, but we couldn\'t complete your purchase. Please try again in a few minutes.');
		},
		complete : function(data) {
			stopSpinning();
			bookingProcessing = false;
		}
	});
});

$('#cart-container').on('change', '.form-card-country', function(e) { 
	var $zip = $('.form-card-zip');
	var $select = $(e.currentTarget);
	var value = $select.val();
	if (value === 'AU') {
		$zip.attr('placeholder', 'Postcode');
	}
	else if (value === 'US') {
		$zip.attr('placeholder', 'ZIP Code');
	}
	else {
		$zip.attr('placeholder', 'Postal Code');
	}
});

/**
 * Show alert
 */
function showAlert(message) {
	$('.alert-row').show().find('.alert-message').html(message);
	stopSpinning();
	bookingProcessing = false;
}

/**
 * Hide alert
 */
function hideAlert() {
	$('.alert-row').attr({ 'style': 'display: none!important' });
}

/**
 * Start spinner
 */
function startSpinner() {
	var opt = $.extend(true, {}, DEFAULT_SPIN_OPTS, { 
		color : '#000',
		scale : 0.20,
		top   : "11px",
		left  : '-20px'
	});
	$spinner = new Spinner(opt).spin($completeButton.find('span')[0]);
}

/**
 * Stop spinner
 */
function stopSpinning() {
	$spinner.stop();
	$completeButton.html(completeButtonText);
}

/**
 * Format price
 */
function formatPrice(price, decimals) {
	if (typeof decimals === 'undefined') {
		decimals = 2;
	}
	var negative = price < 0 ? '-' : '';
	return negative + '$' + Math.abs(price).toFixed(decimals).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

/**
 * Refresh cart
 */
function refreshCart() {
	var data = $('#cart-form').serializeArray();
	$('#cart-container').load(`${document.location.pathname} #cart-form`, function() {
		// persist input values
		data.forEach(function(nv) {
			$('input[name="' + nv.name + '"]').val(nv.value);
		});
		// update cart total in nav
		$('.nav-cart-total').html($('.cart-total').html());
	});
}

// round values to 2 decimals
function round10(num) {
	return +(Math.round(num + "e+" + 2)  + "e-" + 2);
}

// return AM/PM format from military
function formatTime(time) {
	var timezone = '';
	return moment(time, "HH:mm").format("h:mm A") + timezone;
}

/**
 * Upsell 
 */
function checkForUpsell() {
	$.ajax({
		type : "POST",
		data : { 
			action : 'checkForUpsell',
		},
		cache    : false,
		dataType : 'json',
		success : function(response) {
			var $upsell = $('.box-upsell');
			var $row    = $('.form-upsell-row');
			var $item   = $('.form-upsell-item').clone().removeClass('d-none');
			var count   = 0;
			response.data.forEach(function(res) {
				if (res.times.length == 0) {
					return;
				}
				var $itemCopy = $item.clone();
				var price  = (res.prices.taxIncluded ? res.prices.total : res.prices.price) || 0;
				var amount   = round10(res.persons * price);
				$itemCopy.find('.book-image').css({ 'background-image': 'url(\'images/rooms/' + res.room.key + '.jpg\')' }); 
				$itemCopy.find('.book-image img').attr('src', '/images/rooms/banner-' + res.room.key + '.png');
				$itemCopy.find('.book-info').html(res.room.shortText);

				$itemCopy.find('.book-price').html(formatPrice(price));
				$itemCopy.find('.book-guests').html(res.persons);
				$itemCopy.find('.book-room-name').text(res.reservation.name);
				$itemCopy.find('.book-time').text(formatTime(res.times[0].time) + (res.room.time ? ' (' + res.room.time + 'min)' : ''));
				$itemCopy.find('.book-amount').text(formatPrice(amount));
				$itemCopy.find('.button-add-to-cart')
					.attr('data-venue', res.venue.id)
					.attr('data-event', res.reservation.id)
					.attr('data-time', res.times[0].time)
					.attr('data-date', res.date)
					.attr('data-persons', res.persons);
				if (count > 0) {
					$row.append('<div class="col-12"><hr class="hr-grey" /></div>');
				}
				$row.append($itemCopy);
				count += 1;
			});
			if (count) {
				$upsell.removeClass('d-none');
			}
		}
	});
	return false;
}
if (typeof CHECK_FOR_UPSELLL !== 'undefined' && CHECK_FOR_UPSELLL) {
	setTimeout(function() {
		checkForUpsell();
	}, 0);
}
